export default __webpack_public_path__ + "static/media/guideline_3.86ce7be5.svg";